function showVariantImage(imageUrl) {
  var overlay = document.getElementById('variant-image-overlay');
  var image = document.getElementById('variant-image');

  if (imageUrl) {
    image.src = imageUrl;
    overlay.style.display = 'flex';
  } else {
    overlay.style.display = 'none';
  }
}

var touchStartX = 0;
var touchEndX = 0;

function handleSwipeOrClose() {
  var overlay = document.getElementById('variant-image-overlay');
  overlay.style.display = 'none';

  // Move Slick slider to the 4th image (index 3)
  if ($('#ProductPhoto').hasClass('slick-initialized')) {
    $('#ProductPhoto').slick('slickGoTo', 3);
  }
}

// Handle touch swipe manually
document.addEventListener('touchstart', function(e) {
  touchStartX = e.changedTouches[0].screenX;
}, false);

document.addEventListener('touchend', function(e) {
  touchEndX = e.changedTouches[0].screenX;
  if (Math.abs(touchEndX - touchStartX) > 30) { // user swiped at least 30px
    handleSwipeOrClose();
  }
}, false);

// Close button
document.getElementById('close-overlay-button').addEventListener('click', function() {
  handleSwipeOrClose();
});


